<template>
  <div>
    <!--    <b-form-checkbox-->
    <!--      v-model="isAutoUpdateLimitNumber"-->
    <!--      name="check-button"-->
    <!--      class="mb-2"-->
    <!--      switch-->
    <!--      inline-->
    <!--      @input="changeAutoUpdateLimitNumber"-->
    <!--    >-->
    <!--      Auto Update Limit-->
    <!--    </b-form-checkbox>-->
    <b-card>
      <!-- ตัวเกาะบอกได้เฉพาะเรื่องที่ไปต่อเองไม่ได้ ซึ่งแปลว่ามีคนต้องลงมือ จึงต้องเห็นก่อนตาราง -->
      <b-alert
        variant="warning"
        :show="!!mirrorNotice"
        class="mb-1"
      >
        <div class="alert-body d-flex align-items-start">
          <feather-icon
            icon="AlertTriangleIcon"
            size="15"
            class="mr-50 mt-25 flex-shrink-0"
          />
          <span>{{ mirrorNotice }}</span>
        </div>
      </b-alert>

      <b-tabs
        v-model="lastTab"
        @input="changeTab"
      >
        <template #tabs-end>
          <ProdMirrorSwitch @notice="mirrorNotice = $event" />
          <FourFiveDigitModeSwitch class="ml-50" />
        </template>
        <b-tab
          :title="$t('รัฐบาล')"
          lazy
        >
          <LottoInformationTable :type="1" />
        </b-tab>
        <b-tab
          :title="$t('หุ้น')"
          lazy
        >
          <LottoInformationTable :type="2" />
        </b-tab>
        <b-tab
          :title="$t('ยี่กี')"
          lazy
        >
          <YeekeeInformationTable :type="3" />
        </b-tab>
        <b-tab
          :title="$t('เลขชุด')"
          lazy
        >
          <LottoInformationTable :type="4" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BTabs, BTab, BCard, BAlert,
} from 'bootstrap-vue'

import LottoInformationTable from '@/views/components/LottoInformationTable.vue'
import YeekeeInformationTable from '@/views/components/YeekeeInformationTable.vue'
import ProdMirrorSwitch from '@/views/components/ProdMirrorSwitch.vue'
import FourFiveDigitModeSwitch from '@/views/components/FourFiveDigitModeSwitch.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BAlert,
    // BFormCheckbox,
    LottoInformationTable,
    YeekeeInformationTable,
    ProdMirrorSwitch,
    FourFiveDigitModeSwitch,
  },
  data() {
    return {
      lastTab: 0,
      isAutoUpdateLimitNumber: false,
      mirrorNotice: '',
    }
  },
  beforeMount() {
    const tab = localStorage.getItem('lotto-list-tab')
    if (tab) {
      this.lastTab = tab * 1
    }
  },
  methods: {
    changeTab(e) {
      this.lastTab = e
      localStorage.setItem('lotto-list-tab', this.lastTab)
    },
  },
}
</script>

<style lang="scss" scoped>
// จอแคบ สวิตช์จะตกลงไปอยู่บรรทัดใหม่ใต้แท็บจนชนเส้นใต้ของแท็บที่เลือกอยู่
// row-gap มีผลเฉพาะตอนที่แถวขึ้นบรรทัดใหม่จริง ๆ ตอนอยู่บรรทัดเดียวกันไม่มีอะไรเปลี่ยน
// จึงไม่ต้องเดาว่าจอกว้างเท่าไรถึงจะตก
::v-deep .nav-tabs {
  row-gap: 0.5rem;
}
</style>
